import { takeLatest, call, put } from 'redux-saga/effects'
import { getQuestionList } from 'api/administration/questions/List'
import I18n from 'i18n'
import { ErrorToast } from 'components/ui/toast/toastsTemplates'
import * as fromActions from '../../../actions/questions.action'

async function getList(instanceId: number) {
  return await getQuestionList(instanceId)
}

function* questionListEffectSaga(action: any) {
  try {
    const { instanceId } = action
    const data = yield call(getList, instanceId)
    yield put(fromActions.Actions.questionsListSuccess(data))
  } catch (error) {
    // Without this the question editor and cards stay behind a loader.
    yield put(fromActions.Actions.setQuestionLoading(false))
    ErrorToast(I18n.t('administration.toastMessages.genericError'))
    console.log('error: ', error)
  }
}

export function* questionListWatcherSaga() {
  yield takeLatest(fromActions.GET_QUESTIONS_LIST, questionListEffectSaga)
}
